import { Component } from '@theme/component';

/**
 * PPC Best Sellers carousel.
 * Mobile: 4 cards become a horizontal scroller; the progress bar reflects the
 * visible portion of the track. Desktop renders a static 4-column grid and the
 * progress bar is hidden via CSS.
 *
 * @extends Component<{ track: HTMLElement, progressBar?: HTMLElement }>
 */
class PvPpcBest extends Component {
  requiredRefs = ['track'];

  connectedCallback() {
    super.connectedCallback();
    const { track } = this.refs;
    track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#syncProgress();
    window.addEventListener('resize', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const { track } = this.refs;
    track?.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
  }

  #onScroll = () => this.#syncProgress();

  #syncProgress() {
    const { track, progressBar } = this.refs;
    if (!progressBar || !track) return;

    const { scrollLeft, scrollWidth, clientWidth } = track;
    const maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 0) {
      progressBar.style.width = '100%';
      progressBar.style.marginLeft = '0%';
      return;
    }

    const thumbWidth = (clientWidth / scrollWidth) * 100;
    const offset = (scrollLeft / maxScroll) * (100 - thumbWidth);
    progressBar.style.width = `${thumbWidth}%`;
    progressBar.style.marginLeft = `${offset}%`;
  }
}

if (!customElements.get('pv-ppc-best')) {
  customElements.define('pv-ppc-best', PvPpcBest);
}
